// 이 파일은 원보카 개인정보처리방침(한국어) 원문을 그대로 옮긴 것입니다.
// 내용을 수정할 때에는 법무 검토를 거친 원문과 반드시 함께 갱신해 주세요.

import { PolicyBlock } from "./PolicyBlock";

const privacyPolicyKo: PolicyBlock[] = [
  {
    "kind": "heading",
    "text": "제 1조 개인정보의 처리 목적"
  },
  {
    "kind": "paragraph",
    "text": "회사는 다음의 목적을 위해 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며 이용 목적이 변경되는 경우, 개인정보 보호법 제 18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다."
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "회원가입 및 관리",
        "children": [
          {
            "text": "본인 식별 및 인증, 회원 유지 및 관리 목적으로 개인정보를 처리합니다."
          }
        ]
      },
      {
        "text": "서비스 제공",
        "children": [
          {
            "text": "서비스 제공을 목적으로 개인정보를 처리합니다."
          }
        ]
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 2조 개인정보의 처리 및 보유기간"
  },
  {
    "kind": "paragraph",
    "text": "회사는 법령에 따른 개인정보 보유, 이용기간 또는 정보 주체로 부터 개인정보를 수집 시에 동의받은 개인정보 보유, 이용기간 내에서 개인정보를 처리, 보유합니다. 각각의 개인정보 처리 및 보유기간은 다음과 같습니다."
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "회원가입 및 관리",
        "children": [
          {
            "text": "지속적인 서비스 제공을 위해 사용자가 계정을 삭제하거나 서비스 종료시까지 데이터를 보유합니다."
          }
        ]
      },
      {
        "text": "서비스 제공",
        "children": [
          {
            "text": "지속적인 서비스 제공을 위해 사용자가 계정을 삭제하거나 서비스 종료시까지 데이터를 보유합니다."
          }
        ]
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 3조 처리하는 개인정보의 항목"
  },
  {
    "kind": "paragraph",
    "text": "회사는 다음의 개인정보 항목을 처리하고 있습니다."
  },
  {
    "kind": "list",
    "ordered": false,
    "items": [
      {
        "text": "필수항목 : 이메일, 로그인 ID, 서비스 이용 기록, 접속 로그, 결제 기록"
      },
      {
        "text": "선택항목 : ‘애플로그인’을 통해 로그인하는 경우, 이메일 제공 여부를 사용자가 선택할 수 있습니다."
      }
    ]
  },
  {
    "kind": "paragraph",
    "text": "사용자는 앱 내의 계정 삭제 기능을 이용하여 언제든지 개인정보를 삭제할 수 있으며 앱 내의 계정을 삭제하면 회원가입시 등록된 계정 및 앱 이용에 등록 된 모든 데이터가 영구적으로 복원 불가능한 방법으로 삭제됩니다."
  },
  {
    "kind": "paragraph",
    "text": "사용자는 다음 방법으로 계정을 삭제할 수 있습니다."
  },
  {
    "kind": "list",
    "ordered": false,
    "items": [
      {
        "text": "앱 내 설정 → 내 프로필 → 계정 삭제 버튼 클릭"
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 4조 개인정보의 파기절차 및 파기방법"
  },
  {
    "kind": "paragraph",
    "text": "회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다."
  },
  {
    "kind": "paragraph",
    "text": "개인정보 파기의 절차 및 방법은 다음과 같습니다."
  },
  {
    "kind": "list",
    "ordered": false,
    "items": [
      {
        "text": "원보카는 파기 사유자 발생한 개인정보를 선정하고 원보카의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다."
      },
      {
        "text": "전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술의 방법을 사용합니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 5조 미이용자의 개인정보 파기 등에 관한 조치"
  },
  {
    "kind": "paragraph",
    "text": "회사는 3년간 서비스를 이용하지 않은 이용자의 정보를 파기하고 있습니다. 다만, 다른 법령에서 정한 보존기간이 경과할 때까지 다른 이용자의 개인정보와 분리하여 별도로 저장 및 관리할 수 있습니다."
  },
  {
    "kind": "heading",
    "text": "제 6조 정보주체와 법정대리인의 권리, 의무 및 그 행사방법에 관한 사항"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "정보주체는 회사에 언제든지 개인정보 열람, 정정, 삭제, 처리정지 요구 등의 권리를 행사할 수 있습니다."
      },
      {
        "text": "제 1항에 따른 권리 행사는 회사에 대해 개인정보 보호법 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다."
      },
      {
        "text": "제 1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 처리 방법에 관한 고시(제2020-7호) 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다."
      },
      {
        "text": "개인정보 열람 및 처리정지 요구는 개인정보 보호법 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다."
      },
      {
        "text": "개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다."
      },
      {
        "text": "회사는 정보주체 권리에 따른 열람의 요구, 정정, 삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 7조 개인정보의 안전성 확보조치에 관한 사항"
  },
  {
    "kind": "paragraph",
    "text": "회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다."
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위해 보안프로그램을 설치하고 주기적인 갱신 및 점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적, 물리적으로 감시 및 차단하고 있습니다."
      },
      {
        "text": "회사는 사용자의 비밀번호를 수집하지 않아 사용자는 자신의 비밀번호를 오직 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하는 등의 별도 보안기능을 사용하고 있습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 8조 개인정보를 자동으로 수집하는 장치의 설치, 운영 및 그 거부에 관한 사항"
  },
  {
    "kind": "paragraph",
    "text": "회사는 정보주체의 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용하지 않습니다."
  },
  {
    "kind": "heading",
    "text": "제 9조 행태정보의 수집, 이용, 제공 및 거부등에 관한 사항"
  },
  {
    "kind": "paragraph",
    "text": "회사는 앱의 사용성 개선 및 신규 기능 개발에 참고하기 위해 사용자의 행태정보를 이용하고 있으며 사용자의 동의 없이는 행태정보가 수집되지 않습니다."
  },
  {
    "kind": "heading",
    "text": "제 10조 개인정보 보호책임자에 관한 사항"
  },
  {
    "kind": "paragraph",
    "text": "회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다."
  },
  {
    "kind": "list",
    "ordered": false,
    "items": [
      {
        "text": "개인정보보호 책임자",
        "children": [
          {
            "text": "이름 : 김민수"
          },
          {
            "text": "직급 : 대표"
          }
        ]
      },
      {
        "text": "개인정보보호 담당자",
        "children": [
          {
            "text": "이름 : 김민수"
          },
          {
            "text": "직급 : 대표"
          }
        ]
      },
      {
        "text": "담당 부서 이메일 : zak1ller.kr@gmail.com"
      }
    ]
  },
  {
    "kind": "paragraph",
    "text": "기타 개인정보 침해에 대한 신고나 상담이 필요한 경우 아래 기타에 문의 가능합니다."
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)"
      },
      {
        "text": "개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)"
      },
      {
        "text": "대검찰청 : (국번없이) 1301 (www.spo.go.kr)"
      },
      {
        "text": "경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)"
      }
    ]
  },
  {
    "kind": "paragraph",
    "text": "본 개인정보처리방침은 2022년 6월 13일부터 적용됩니다."
  }
];

export default privacyPolicyKo;
